import type { LoanPayment as GQLItem } from '../../../generated/internal.graphql';
import { take } from '../../../util/takePayload';

/**
 * A single amount recouped against a Soundcheck loan. Every field is non-null on the internal
 * schema, so unlike its parent loan there is no `null` to map away.
 */
export type LoanPayment = {
  id: number;
  amount: number;
  status: string;
  createdAt: string;
};

export const fromGql = (item: GQLItem): LoanPayment =>
  take<LoanPayment>(item, 'id', 'amount', 'status', 'createdAt');
